export default __webpack_public_path__ + "static/media/leg-right-side.e3da1b51.png";